import { truncateZeros } from '../../ModificationsUtils';

export const getFilteredOptions = (currentModDetails, housingProviderId?) => {
  if (!currentModDetails?.housingOptions || !housingProviderId) {
    return [];
  }

  return currentModDetails.housingOptions
    .filter(y => y.housingProviderId === housingProviderId)
    .map(y => ({ Id: y.actualHousingTypeId, Description: y.descHousing }))
};

export const updateStandardAmount = (modDetails, setValue, id) => {
  if (id) {
    if (modDetails && modDetails.housingOptions) {
      const standard = modDetails.housingOptions.find(x => x.actualHousingTypeId === id && x.amount > 0);
      setValue('standardAmountCharged', standard ? truncateZeros(standard.amount) : truncateZeros(0));
    }
  }
};
